import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const userData = inject(AuthService).getUserData();
  if (userData != null) {
    const newReq = req.clone({
      headers: req.headers.append('Authorization', `Bearer ${userData.accessToken}`)
    });
    return next(newReq);
  }
  return next(req);
};
